import './_product-card-rating.scss';

export default () => {};
